document.addEventListener('DOMContentLoaded', () => {
  const scrollBtn = document.getElementById('scrolltop')
  if (!scrollBtn) return

  scrollBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })
})
